__turbopack_context__.v({
  "art": "testimonial-card-module-scss-module__FSmM7a__art",
  "attribution": "testimonial-card-module-scss-module__FSmM7a__attribution",
  "body": "testimonial-card-module-scss-module__FSmM7a__body",
  "card": "testimonial-card-module-scss-module__FSmM7a__card",
  "content": "testimonial-card-module-scss-module__FSmM7a__content",
  "meta": "testimonial-card-module-scss-module__FSmM7a__meta",
  "name": "testimonial-card-module-scss-module__FSmM7a__name",
  "quote": "testimonial-card-module-scss-module__FSmM7a__quote",
  "quote-icon": "testimonial-card-module-scss-module__FSmM7a__quote-icon",
  "role": "testimonial-card-module-scss-module__FSmM7a__role",
});
